import http from './http'

const getConfigurations = async () => (await http.get('/utils/configurations')).data.data

const getDictionaryTypes = async ({ id }) => (await http.get(`/${id}/dictionary/type`)).data.data.docs

const getDictionaryFields = async ({ id }) => (await http.get(`/${id}/dictionary/field`)).data.data.docs

const updateDictionary = async (id, payload) => (await http.patch(`/${id}/dictionary`, payload)).data

export {
  getConfigurations,
  getDictionaryTypes,
  getDictionaryFields,
  updateDictionary
}
